import { Col, Grid, Row, Span } from 'components'
import { ExpandIcon } from 'components/Icons'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'

import {
  CardContentStyled,
  CardStyled,
  CollapseInfo,
  CollapseStyled
} from './CollapseColumnBlock.styles'
import WarningIcon from '@mui/icons-material/Warning';


interface ICollapseColumn {
  nuContrato?: string
  nmFornecedor?: string
  nmContraparte?: string
  nmDiretoriaExecutiva?: string
  nmDiretoria?: string
  nmGerenciaGeral?: string
  nmGerencia?: string
  nmSolicitanteBloqueio?: string
  motivoBloqueio?: string
  motivoBloqueioForn?: string
  dataBloqueio?: string
  dtBloqueioFornecedor?: string
  observacaoBloqueioForn?: string
  analistaBloqForn?: string
  usuarioSolicitanteBloqForn? : string
  dataLiberacao?: string
  dataEmissao?: string
  vlRisco?: number
  isOpen?: boolean
  fixedOpen?: boolean
  toggleExpand?: (_id: any) => void
  index: number,
  showCollapse?: boolean
}
const CollapseColumnBlock: React.FC<ICollapseColumn> = ({
  nuContrato,
  nmFornecedor,
  nmContraparte,
  nmDiretoriaExecutiva,
  nmDiretoria,
  nmGerencia,
  nmGerenciaGeral,
  nmSolicitanteBloqueio,
  motivoBloqueio,
  motivoBloqueioForn,
  children,
  vlRisco,
  dataBloqueio,
  dtBloqueioFornecedor,
  analistaBloqForn,
  usuarioSolicitanteBloqForn,
  observacaoBloqueioForn,
  dataLiberacao,
  dataEmissao,
  isOpen = false,
  toggleExpand,
  index,
  fixedOpen,
  showCollapse
}) => {
  return (
    <CardStyled elevation={3}>
      <CardContentStyled isHeader>
        <CollapseInfo>
          {!showCollapse ? (
            <Row alignItems="center" justifyContent="center" style={{ padding: '20px', borderRadius: '8px' }}>
              <WarningIcon color="warning" style={{ marginRight: '10px', fontSize: '24px', marginBottom: '0.25rem' }} />
              <Span
                text="Este registro selecionado não possui Folhas de Registro bloqueadas para visualização das informações do card."
                fontSize="19px"
                color={COLORS.error}
                fontWeight={FONTS.bold}
                style={{ marginBottom: '0.25rem' }}
              />
            </Row>
          ) : (
            <>
              {nuContrato ? (
                <Row alignItems="center" justifyContent="space-between" >
                  <Row alignItems="center">
                    <Span
                      text="Contrato:"
                      fontSize="19px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={nuContrato}
                      fontSize="19px"
                      fontWeight={FONTS.bold}
                      color={COLORS.blueFonts}
                    />
                  </Row>

                  <ExpandIcon
                    isExpanded={!isOpen}
                    onClick={() => toggleExpand(index)}
                  />
                </Row>
              ) : (
                <Row alignItems="center" justifyContent="end">
                  <ExpandIcon
                    isExpanded={!isOpen}
                    onClick={() => toggleExpand(index)}
                  />
                </Row>
              )}

              <Col
                //alignItems="start"
                justifyContent="center"
                marginBottom={SPACING.spacing10}
                marginTop={SPACING.spacing10}
              >
                <Row alignItems="center">
                  <Span
                    text="Fornecedor:"
                    fontSize="19px"
                    color={COLORS.black}
                    fontWeight={FONTS.bold}
                    marginRight={SPACING.spacing5}
                  />
                  <Span
                    text={nmFornecedor}
                    fontSize={TYPOGRAPHY.bodySize16}
                    color={COLORS.black}
                  />
                </Row>
                <Grid
                  gridCols="5.9fr 1.1fr"
                  gridGap={`0 ${SPACING.spacing5}`}
                  margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
                >
                  <Row alignItems="center">
                    <Span
                      text="Contraparte:"
                      fontSize="19px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={nmContraparte}
                      fontSize={TYPOGRAPHY.bodySize16}
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center">
                    <Span
                      text="Data Emissão:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span text={dataEmissao} fontSize="13px" color={COLORS.black} />
                  </Row>
                </Grid>
                <Grid
                  gridCols="2.5fr 2.5fr 1fr 1fr"
                  gridGap={`0 ${SPACING.spacing5}`}
                  margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
                >
                  <Row alignItems="center">
                    <Span
                      text="DE:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={nmDiretoriaExecutiva}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing20}>
                    <Span
                      text="DIR:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span text={nmDiretoria} fontSize="13px" color={COLORS.black} />
                  </Row>
                </Grid>
                <Grid
                  gridCols="2.5fr 2.5fr 1fr 1fr"
                  gridGap={`0 ${SPACING.spacing5}`}
                  margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
                >
                  <Row alignItems="center">
                    <Span
                      text="GG:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={nmGerenciaGeral}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing20}>
                    <Span
                      text="GER:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span text={nmGerencia} fontSize="13px" color={COLORS.black} />
                  </Row>
                </Grid>
                <Grid
                  gridCols="2.5fr 2.3fr 2.3fr 1.1fr 1.1fr"
                  gridGap={`0 ${SPACING.spacing5}`}
                  margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
                >
                  <Row alignItems="center">
                    <Span
                      text="Solicitante Bloqueio:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={nmSolicitanteBloqueio}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing5}>
                    <Span
                      text="Data Bloqueio:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={dataBloqueio}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing5}>
                    <Span
                      text="Data Liberação:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={dataLiberacao === "01/01/0001" ? "- - - -" : dataLiberacao}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing5}>
                    <Span
                      text="Motivo Bloqueio:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                      //marginBottom={SPACING.spacing50}
                    />
                    <Span
                      text={motivoBloqueio}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" justifyContent="space-between">
                    <Row alignItems="center">
                      <Span
                        text="Valor de Risco:"
                        fontSize="13px"
                        color={COLORS.black}
                        fontWeight={FONTS.bold}
                        marginRight={SPACING.spacing5}
                      />
                      <Span
                        text={FORMAT.currency(vlRisco ?? 0)}
                        fontSize="13px"
                        color={COLORS.black}
                        
                      />
                    </Row>
                  </Row>

                  <Row alignItems="center" marginLeft={SPACING.spacing5}>
                    <Span
                      text="Motivo Bloqueio Fornecedor:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={motivoBloqueioForn}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing5}>
                    <Span
                      text="Solicitante Bloqueio Fornecedor:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={usuarioSolicitanteBloqForn}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing5}>
                    <Span
                      text="Analista Bloqueio Fornecedor:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={analistaBloqForn}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  <Row alignItems="center" marginLeft={SPACING.spacing5}>
                    <Span
                      text="Data Bloqueio Fornecedor:"
                      fontSize="13px"
                      color={COLORS.black}
                      fontWeight={FONTS.bold}
                      marginRight={SPACING.spacing5}
                    />
                    <Span
                      text={dtBloqueioFornecedor}
                      fontSize="13px"
                      color={COLORS.black}
                    />
                  </Row>
                  
                </Grid>
              </Col>
            </>
          )}
        </CollapseInfo>
      </CardContentStyled >
      <CollapseStyled
        in={fixedOpen ? fixedOpen : isOpen}
        timeout="auto"
        unmountOnExit
      >
        <CardContentStyled>{children}</CardContentStyled>
      </CollapseStyled>
    </CardStyled >
  )
}

export default CollapseColumnBlock
